import { Box, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import { accordionButtonStyles } from "./MenuLinkWithSubmenu.styles";
import { SubmenuContent } from "./SubmenuContent";

export const MenuLinkWithSubmenuMobile = ({
  menulink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menulink: JSX.Element;
}) => (
  <Accordion allowToggle defaultIndex={null}>
    <AccordionItem border="none" bg="transparent">
      <AccordionButton
        py={0}
        pl={0}
        fontSize="lg"
        borderRadius="sm"
        data-testid="open-kyr-items"
        sx={accordionButtonStyles}
      >
        <Box flex="1" textAlign="left">
          {menulink}
        </Box>
        <AccordionIcon boxSize={6} />
      </AccordionButton>
      <AccordionPanel p={0} mt={7}>
        <SubmenuContent submenu={submenu} mb={4} ml={2} fontSize="md" data-testid="kyr-list-items" _last={{ mb: 2 }} />
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);
